import { inject, observer } from "mobx-react";
const RootStore = inject("rootStore")(
  observer((props) => {
    return props.children(props.rootStore);
  })
);

export default RootStore;
